import { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const ForcePasswordChangeForm = ({ currentPassword, onDone }) => {
    const { changeInitialPassword } = useAdminAuth();
    const [newPassword, setNewPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirm) { toast.error('Las contraseñas no coinciden'); return; }
        setLoading(true);
        try {
            await changeInitialPassword(currentPassword, newPassword);
            toast.success('Contraseña actualizada. Bienvenido.');
            onDone();
        } catch (err) {
            const d = err.response?.data?.detail;
            toast.error(typeof d === 'string' ? d : 'No se pudo cambiar la contraseña');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={submit} className="space-y-4" data-testid="admin-force-pw-form">
            <p className="text-xs text-muted-foreground">Mínimo 8 caracteres, con mayúscula, minúscula, número y un carácter especial.</p>
            <div className="space-y-2">
                <Label htmlFor="new-pw">Nueva contraseña</Label>
                <Input id="new-pw" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required autoFocus className="input-aviation" data-testid="admin-force-pw-new" />
            </div>
            <div className="space-y-2">
                <Label htmlFor="confirm-pw">Confirmar contraseña</Label>
                <Input id="confirm-pw" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="input-aviation" data-testid="admin-force-pw-confirm" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-amber-500 hover:bg-amber-600 text-black font-bold uppercase tracking-wider text-xs" data-testid="admin-force-pw-submit">
                {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
                Guardar y entrar
            </Button>
        </form>
    );
};
